"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createValidator = exports.ajv = void 0;

var _ajv = _interopRequireDefault(require("ajv"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ajv = new _ajv.default({
  allErrors: true,
  useDefaults: true
});
exports.ajv = ajv;

var createValidator = function createValidator(schema) {
  var validator = ajv.compile(schema);
  return function (model) {
    validator(model);

    if (validator.errors && validator.errors.length) {
      // eslint-disable-next-line no-throw-literal
      throw {
        details: validator.errors
      };
    }
  };
};

exports.createValidator = createValidator;
var _default = createValidator;
exports.default = _default;